import axios from 'axios';
import handleError from 'services/handleError';

import {
  AI_PHOTOSHOOTING__BASE_PATH,
  BG_REMOVE__BASE_PATH,
  AI_FASHION_STORE__BASE_PATH,
} from 'utils/configs';

const sendFeedback = async (value, toolPath, taskId, mediaId, thunkAPI) => {
  let dynamicUrlPart = `/image/${mediaId}`;

  if (
    (mediaId && toolPath === `${AI_PHOTOSHOOTING__BASE_PATH}/task`) ||
    (mediaId && toolPath === `${BG_REMOVE__BASE_PATH}/task`)
  ) {
    dynamicUrlPart = `/result/${mediaId}`;
  } else if (toolPath === AI_FASHION_STORE__BASE_PATH) {
    dynamicUrlPart = '';
  }

  try {
    await axios.post(`${toolPath}/${taskId}${dynamicUrlPart}/feedback`, {
      value,
    });

    return { mediaId, value };
  } catch (error) {
    if (!error.response) {
      return thunkAPI.rejectWithValue({
        message:
          'Network error. Please check your internet connection or try again later.',
        errorType: error.code || 'network_error',
        details: error.message,
      });
    }

    const status = error.response?.status;
    const data = error.response?.data;

    const errorDetails = await handleError(status, data);

    return thunkAPI.rejectWithValue(errorDetails);
  }
};

export default sendFeedback;
